/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import {connect} from "react-redux";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import Configuration from "../../../Server/Configuration";
import Label from "../../../Components/Control/Label";
import Separator from "../../../Components/Control/Separator";
import BarcodeReader from 'react-barcode-reader';
import ModalHemo from "../ModalProduct";
import Product from '../../../Server/Product';
import MyComponent from '../../../Components/MyComponent';

class ModalProductScan extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        props.refer.current = this;

        this.state = {
            title: {
                INSERT: 'ثبت فرآورده جدید',
                UPDATE: 'ویرایش فرآورده',
                VIEW: 'اطلاعات فرآورده'
            },
            bloodGroups: [
                {id: '', text: '...'},
                ...props.base.bloodGroups.map(item => {
                    return {id: item.id, text: item.name};
                })
            ],
            productTypes: [
                {id: '', text: '...'},
                ...props.base.productTypes.map(item => {
                    return {id: item.id, text: item.name, data: item};
                })
            ],
            fields: {},
            error: false,
            updated: false // this checks weather modal has been changed something or not
        };

        this.ref = {
            modal: React.createRef(),
            modalHemo: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            close: React.createRef(),
            receiverUserId: React.createRef(),
            receiveDateTime: React.createRef(),
            bloodGroupId: React.createRef(),
            productTypeId: React.createRef(),
            productNumber: React.createRef(),
            expireDate: React.createRef(),
            cellTypeTest: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };
    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };
    validations = {
        receiverUserId: x => Boolean(x && x[0]?.id) || 'نام کاربر تحویل گیرنده وارد نشده است.',
        receiveDateTime: x => Boolean(x) || 'تاریخ تحویل وارد نشده است.',
        bloodGroupId: x => Boolean(x && x[0]?.id) || 'گروه خونی انتخاب نشده',
        productTypeId: x => Boolean(x && x[0]?.id) || 'نوع فرآورده انتخاب نشده',
        productNumber: x => Boolean(x) || 'شماره فرآورده وارد نشده',
        expireDate: x => Boolean(x) || 'تاریخ انقضا فرآورده وارد نشده'
    };

    componentDidMount() {
        Configuration.usersList({hospitalId: this.props.hospitalId})
            .then(list => {
                this.setState({
                    users: [{id: '', text: '...'},
                        ...list.map(item => {
                            return {id: item.userId, text: item.fullName};
                        })]
                });
            });
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields ||
            state.users !== nextState.users;
    }

    render() {
        const {state, ref} = this;

        return <React.Fragment>
            <Modal ref={ref.modal}
                   name={'ModalProductScan'}
                   size={'medium'}
                   title={'افزودن فرآورده از طریق بارکد'}
                   error={state.error}
                   onClose={_ => {
                       if (this.state.updated)
                           this.props.onSuccess();
                   }}>
                <ModalContent>
                    <div className={'dis-f'}>
                        <BarcodeReader
                            onScan={this.barcodeScanHandler.bind(this)}/>
                        <div className={state.fields.productNumber ? 'green' : 'red'}>
                            <Label>شماره فرآورده</Label>
                            <Label size={'large'} align={'center'} className={'fb-20'}>{state.fields.productNumber || '-'}</Label>
                        </div>
                        <Separator/>
                        <div className={'dis-f fb-20'}>
                            <div className={'fb-10 dis-f pad-e-4'}>
                                <div className={state.fields.bloodGroup?.name ? 'green' : 'red'}>
                                    <Label>گروه خونی</Label>
                                    <Label size={'large'} align={'center'} className={'fb-20'}>{state.fields.bloodGroup?.name || '-'}</Label>
                                </div>
                            </div>
                            <div className={'fb-10 dis-f pad-s-4'}>
                                <div className={state.fields.productType?.name ? 'green' : 'red'}>
                                    <Label>نوع فرآورده</Label>
                                    <Label size={'large'} align={'center'} className={'fb-20'}>{state.fields.productType?.name || '-'}</Label>
                                </div>
                            </div>
                        </div>
                        <Separator/>
                        <div className={'dis-f fb-20'}>
                            <div className={'fb-10 dis-f pad-e-4'}>
                                <div className={state.fields?.collectionDate ? 'green' : 'red'}>
                                    <Label>تاریخ اهدا</Label>
                                    <Label size={'large'} align={'center'} className={'fb-20'}>{state.fields?.collectionDate?.format('jYYYY/jMM/jDD') || '-'}</Label>
                                </div>
                            </div>
                            <div className={'fb-10 dis-f pad-s-4'}>
                                <div className={state.fields?.expireDate ? 'green' : 'red'}>
                                    <Label>تاریخ انقضا</Label>
                                    <Label size={'large'} align={'center'} className={'fb-20'}>{state.fields?.expireDate?.format('jYYYY/jMM/jDD') || '-'}</Label>
                                </div>
                            </div>
                        </div>
                        {state.fields.productType?.enzymeType == 1 && <React.Fragment>
                            <Separator/>
                            <div className={state.fields?.cellTypeTest ? 'green' : 'red'}>
                                <Label>آزمایش سل تایپ</Label>
                                <Label size={'large'} align={'center'} className={'fb-20'}>{state.fields?.cellTypeTest ? 'انجام گرفته' : 'انجام نگرفته'}</Label>
                            </div>
                        </React.Fragment>}
                        <Separator/>
                        <div style={{display: 'flex', width: '100%', justifyContent: 'space-between'}}>
                            <div className={'barcode'}>
                                <Label>ثبت فرآورده</Label>
                                <img src={Resource.IMAGE.INSERT_BARCODE} alt={''}/>
                            </div>
                            <div className={'barcode'}>
                                <Label>وضعیت آزمایش سل تایپ</Label>
                                <img src={Resource.IMAGE.CELL_TYPE_BARCODE} alt={''}/>
                            </div>
                            <div className={'barcode'}>
                                <Label>حذف اطلاعات فرم</Label>
                                <img src={Resource.IMAGE.CLEAR_BARCODE} alt={''}/>
                            </div>
                        </div>
                    </div>
                </ModalContent>
                <ModalControls>
                    <Button refer={ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت فرآورده</Button>
                    <Button refer={ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش فرآورده</Button>
                    <Button refer={ref.close} className={'mar-4'} onClick={this.clearClickHandler.bind(this)}>پاک کردن</Button>
                    <Button refer={ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalHemo refer={ref.modalHemo}/>
        </React.Fragment>;
    }

    barcodeScanHandler(code) {
        //commands
        switch (code) {
            case 'INSERT':
                this.insertClickHandler();
                return;
            case 'CLEAR_FORM':
                this.clearClickHandler();
                return;
            case 'CELL_TYPE':
                this.setField('cellTypeTest', !this.state.fields?.cellTypeTest);
                return;
            default:
                break;
        }

        //barcodes
        const barcode = Tool.checkBarcode(code);
        switch (barcode.type) {
            case 'PRODUCT_EXPIRE_DATE':
                this.setField('expireDate', barcode.data);
                break;
            case 'PRODUCT_COLLECTION_DATE':
                this.setField('collectionDate', barcode.data);
                break;
            case 'PRODUCT_BLOOD_GROUP':
                this.setField('bloodGroup', barcode.data);
                break;
            case 'PRODUCT_TYPE':
                this.setField('productType', barcode.data);
                break;
            case 'PRODUCT_NUMBER':
                this.setField('productNumber', barcode.data);
                break;
            default:
                break;
        }
    }

    clearClickHandler() {
        this.setState({
            fields: {}
        });
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true || this.state.updated)
            this.props.onSuccess();

        this.props.onClose();
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            Product.insert({
                bloodGroupId: state.fields?.bloodGroup?.id,
                productTypeId: state.fields?.productType?.id,
                productNumber: state.fields?.productNumber,
                expireDate: state.fields?.expireDate.format(),
                collectionDate: state.fields?.collectionDate.format(),
                cellTypeTest: state.fields.productType?.enzymeType == 1 ? state.fields?.cellTypeTest || false : null
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();
                ref.insert.current.loading(false);

                this.clearClickHandler();

                this.setState({
                    updated: true
                });
            }).catch(message => {
                ref.insert.current.loading(false);

                this.setState({error: message});
            });
        }
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                error: null,
                updated: false
            });
        }

        return this.ref.modal.current.open();
    }

    submitBarcodeClickHandler() {
        this.setState({
            waitingSubmitBarcode: true
        });
    }

    updateClickHandler() {
        const {state} = this;
        this.ref.modalHemo.current.open({
            productNumber: state.fields.productNumber || undefined,
            expireDate: state.fields.expireDate || undefined,
            collectionDate: state.fields.collectionDate || undefined,
            bloodGroupId: state.fields.bloodGroup ? [{id: state.fields.bloodGroup.id}] : undefined,
            productTypeId: state.fields.productType ? [{id: state.fields.productType.id, data: state.fields.productType}] : undefined,
            cellTypeTest: state.fields.productType?.enzymeType == 1 ? state.fields?.cellTypeTest || false : null
        }, ModalAction.INSERT);
    }

    validate() {
        const {state} = this;

        return state.fields.productNumber &&
            state.fields.expireDate &&
            state.fields.collectionDate &&
            state.fields.bloodGroup &&
            state.fields.productType;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        hospitalId: state.user?.hospitalId
    };
};

export default connect(mapStateToProps)(ModalProductScan)